import { signOut } from './betterAuthClient'
import { clearAuthToken } from './guestAuth'

export const performLogout = async (isGuest: boolean): Promise<void> => {
  try {
    if (isGuest) {
      clearAuthToken()
    } else {
      try {
        // Try the proper better-auth logout first
        const result = await signOut()
      } catch (authError) {
        console.warn(
          'Better-auth signOut failed, clearing manually:',
          authError
        )

        // Fallback: clear auth cookies manually
        // Clear all cookies for this domain
        const cookies = document.cookie.split(';')
        for (let cookie of cookies) {
          const eqPos = cookie.indexOf('=')
          const name =
            eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()

          // Clear cookie for current path and root path
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=localhost`
        }

        // Clear any auth-related localStorage items
        const authKeys = [
          'better-auth-session',
          'better-auth-token',
          'auth-token',
        ]
        authKeys.forEach((key) => {
          localStorage.removeItem(key)
          sessionStorage.removeItem(key)
        })
      }
    }
  } catch (error) {
    console.error('Logout error:', error)
    throw error
  }
}
